import styled from "styled-components"

const OpenButton = styled.button`
  align-items: center;
  background-color: #ffff;
  border-radius: 50%;
  border: none;
  color: #30a7d7;
  cursor: pointer;
  display: flex;
  font-size: medium;
  font-weight: bold;
  height: 16px;
  justify-content: center;
  width: 16px;
`

export default OpenButton
